module.exports = __webpack_public_path__ + "img/oosaka.3df8eb36.jpg";